// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__A9EbG","left":"StickyBox_left__1pZfy","right":"StickyBox_right__1YdIG"};